import {createDescriptionObjectForList, createListFromObject} from "../../Utilities/Types/listUtilities";

export const CENSUS_STATUS = {
    CensusOpen: createDescriptionObjectForList("1", "Census Open"),
    CensusFimcAdminReview: createDescriptionObjectForList("2", "Census FIMC Admin Review"),
    CensusEnd: createDescriptionObjectForList("3", "Census End"),
};

export function getCensusStatusList() {
    return createListFromObject(CENSUS_STATUS);
}